export var JWT_COOKIE_KEY = 'jwt';
export var REFRESH_COOKIE_KEY = 'refresh_jwt';
export function isExpired(token, skew) {
    if (skew === void 0) { skew = 0; }
    return !!token.exp && token.exp * 1000 - skew < Date.now();
}
//# sourceMappingURL=token.service.js.map